<template>
	<div class="search-wrapper">
		<div class="banner-form">
			<div class="tab-content" id="myTabContent">
				<div class="tab-pane fade show active" id="flight" role="tabpanel" aria-labelledby="flight-tab">
					<form name="" id="search-form" class="d-flex-inline flex-nowrap" method="get" action="" @submit="search($event)">
						<div class="row no-gutters search-form-div">
							<div class="col-12 col-md-8 md-offset-2 col-lg-6 lg-offset-3">
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text" id="search-form-search"><i class="fas fa-search fa-fw"></i></span>
									</div>
									<input autocomplete="off" type="text" @keyup="suggest()" id="service" v-model="keyword" class="form-control" placeholder="Traži uslugu/salon" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Traži uslugu/salon'">
									<div class="input-group-append">
										<button type="submit" id="search-form-submit" class="fs-btn"><i id="search-form-plane" class="fas fa-paper-plane fa-fw"></i></button>
									</div>
								</div>
								<div class="result-container">
									<div v-if="result.length > 0" class="result">
										<ul>
											<li v-for="(res,index) in result" :key="index">
												<span><i class="fas fa-search fa-fw"></i></span>
												<a :href="'salon/'+res.salon.name" v-if="res.type == 'service'">
													<span class="service">{{res.name}}</span>
													<span class="salon">{{res.salon.name}}</span>
												</a>
												<a :href="'salon/'+res.name" v-if="res.type == 'salon'">
													<!-- <span class="service">{{res.name}}</span> -->
													<span class="salon">{{res.name}}</span>
												</a>
											</li>
											<li v-if="finishedSearching && result.length == 0" style="color:red;text-align:center;font-size:12px" class="norf">Nema pronađenih rezultata</li>
										</ul>
									</div>
								</div>

								<!-- <div class="search-form-section d-none d-sm-flex">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="search-form-marker"><i class="fas fa-map-marker-alt fa-fw"></i></span>
                                    </div>
                                    <input type="text" id="location" :value="location != undefined ? location:''" class="form-control" placeholder="Lokacija" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Lokacija'">
                                </div>
                            </div> -->
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "search",
		props: ['service', 'location'],
		data() {
			return {
				keyword: '',
				result: [],
				finishedSearching: false
			}
		},
		methods: {
			search(e) {
				e.preventDefault();
				var url = "/salon-list?service=" + document.getElementById('service').value;
				window.location.href = url;
			},
			suggest() {
				if (this.keyword.length == 0) {
					this.result = [];
					return false;
				}
				this.$store.dispatch('post', {
						details: {
							service: this.keyword
						},
						endpoint: this.$store.state.endpoint + 'suggestion'
					})
					.then((data) => {
						console.log(data);
						this.result = data.data;
					})
					.catch((error) => {
						console.log(error.request);
					});
			}
		},
		created() {
			this.keyword = this.service;
		}
	}

</script>
